module.exports = __webpack_public_path__ + "static/dispatch_img-0cc612c603a24aad3e95f7b0671092bf.png";